<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('银行列表')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
      <template #right>
        <van-icon color="#fff" name="plus" @click="onAddClick"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="card-container">
        <div v-for="(bank, index) in bankInfoList" :key="index" class="bank-card">
          <div class="bank-details">
            <div class="account-number">{{ bank.bankName }}</div>
            <div v-if="bank.account" class="row">
              <div class="label">{{ bank.bankName === 'USDT' ||bank.bankName === 'USDT' ||bank.bankName === 'USDT' ? $t('地址') :$t('银行账户号码') }}</div>
              <div class="value">{{ bank.account }}</div>
            </div>
            <div v-if="bank.address" class="row">
              <div class="label">{{ $t('地址') }}</div>
              <div class="value">{{ bank.address }}</div>
            </div>
            <div v-if="bank.owner" class="row">
              <div class="label">{{ $t('姓名') }}</div>
              <div class="value">{{ bank.owner }}</div>
            </div>
          </div>
        </div>
        <div v-if="!bankInfoList.length" class="empty">
          <van-empty :description="$t('暂无数据') + '！'"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banks: [],
      showCoinType: false,
      showWithdrawType: false,
      userInfo: {},
      bankid: "",
      bank: "",
      activeWithdrawType: '',
      bankInfoList: []
    };
  },
  computed: {
    withdrawType() {
      return [this.$t('银行卡'), this.$t('虚拟币')]
    },
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getBankList() {
      this.$http({
        method: 'get',
        url: 'userBankList'
      }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          this.bankInfoList = res.data
          console.log("=>(BankList.vue:99) res.data", res.data);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    onAddClick() {
      const cryptoList = ['USDT','ETH','BTC']
      // 判断数组的x属性是否包含至少一个cryptoList的元素和至少一个不是cryptoList的元素
      const isFull = this.bankInfoList.some(item => cryptoList.includes(item.bankName)) && this.bankInfoList.some(item => !cryptoList.includes(item.bankName))
      if (isFull) {
        this.$toast({message: this.$t('绑定上限，请联系客服!'),type: "fail"});
        return;
      }

      this.$router.push({path: '/BindCard?from=BankList'})
    }
  },
  created() {
    this.activeWithdrawType = this.withdrawType[0];
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
      this.getBankList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container {
  display: flex;
  flex-direction: column;
}

.van-cell {
  font-size: 32px;
  line-height: 80px;
  display: block;
}

::v-deep .van-field__label {
  width: fit-content;
}

.van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.bankbox {
  padding: 15px;
  color: #000;
  background-color: #fff;
}

.bankbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.main-box {
  padding: 0 8px;
  background: #fff;
  flex: 1;
}

.main-box .label {
  padding: 5px;
  font-size: 28px;
}

::v-deep .van-picker__toolbar {
  height: 50px;
}

::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}

::v-deep .van-picker-column {
  font-size: 40px;
}

.main-box p {
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}

.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}

::v-deep .van-icon-arrow {
  font-size: 30px !important;
}

::v-deep .van-cell__title {
  font-size: 30px !important;
}

::v-deep .van-picker__cancel, ::v-deep .van-picker__confirm {
  font-size: 32px !important;
}


.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  padding: 20px;
}

.bank-card {
  width: 100%;
  background: linear-gradient(135deg, #47350D 0%, #7A5C2E 100%);
  color: white;
  border-radius: 15px;
  padding: 15px 15px 5px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  position: relative;
  margin-bottom: 20px;
  font-family: 'Arial', sans-serif;
  overflow: hidden;
}

.bank-card::before {
  content: "";
  position: absolute;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 25%, transparent 25%);
  background-size: 30px 30px;
  top: -50%;
  left: -50%;
  transform: rotate(45deg);
  opacity: 0.5;
}

.bank-logo {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 25px;
}

.bank-chip {
  width: 40px;
  height: 30px;
  background-color: #d4af37;
  border-radius: 4px;
  position: absolute;
  top: 50px;
  left: 20px;
}

.bank-details {
  margin-top: 10px;
}

.account-number {
  font-size: 35px;
  letter-spacing: 2px;
  margin-bottom: 15px;
  font-weight: bold;
}

.row {
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-between;
  margin-bottom: 8px;
}

.label {
  width: 50%;
  color: #fff;
  font-size: 14px;
}

.value {
  width: 50%;
  font-size: 26px;
  text-align: right;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}

/* 右上角的按钮样式 */
.action-buttons {
  position: absolute;
  top: 10px;
  right: 10px;
}

.edit-button,
.unbind-button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 12px;
  padding: 5px 10px;
  margin-left: 5px;
  border-radius: 5px;
  cursor: pointer;
}

button::after {
  border: 0;
}

.edit-button:hover,
.unbind-button:hover {
  background: rgba(255, 255, 255, 0.3);
}

.empty {
  p {
    color: #7d7c7c;
  }
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  // 主内容区域PC端适配
  .main-box {
    padding: 0 5px !important; /* 8px * 0.5733 ≈ 5px */
  }

  // 银行卡卡片容器PC端适配 - 重点修复高度
  .card-container {
    padding: 11px !important; /* 20px * 0.5733 ≈ 11px - 这是影响高度的关键 */
  }

  // 银行卡卡片PC端适配 - 重点修复高度
  .bank-card {
    border-radius: 9px !important; /* 15px * 0.5733 ≈ 9px */
    padding: 9px 9px 3px !important; /* 15px * 0.5733 ≈ 9px, 5px * 0.5733 ≈ 3px - 这是影响高度的关键 */
    margin-bottom: 11px !important; /* 20px * 0.5733 ≈ 11px */
    box-shadow: 0 2px 9px rgba(0, 0, 0, 0.5) !important; /* 4px * 0.5733 ≈ 2px, 15px * 0.5733 ≈ 9px */
  }

  .bank-card::before {
    background-size: 17px 17px !important; /* 30px * 0.5733 ≈ 17px */
  }

  // 银行卡详情PC端适配 - 重点修复高度
  .bank-details {
    margin-top: 6px !important; /* 10px * 0.5733 ≈ 6px */
  }

  .account-number {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    letter-spacing: 1px !important; /* 2px * 0.5733 ≈ 1px */
    margin-bottom: 9px !important; /* 15px * 0.5733 ≈ 9px - 这是影响高度的关键 */
  }

  .row {
    margin-top: 17px !important; /* 30px * 0.5733 ≈ 17px - 这是影响高度的关键 */
    margin-bottom: 5px !important; /* 8px * 0.5733 ≈ 5px - 这是影响高度的关键 */
  }

  .label {
    font-size: 16px !important; /* 14px * 0.5733 ≈ 8px */
  }

  .value {
    font-size: 15px !important; /* 26px * 0.5733 ≈ 15px */
  }

  // 空状态PC端适配
  ::v-deep .van-empty__image {
    width: 172px !important; /* 300px * 0.5733 ≈ 172px */
    height: 172px !important; /* 300px * 0.5733 ≈ 172px */
  }

  ::v-deep .van-empty__description {
    font-size: 17px !important; /* 30px * 0.5733 ≈ 17px */
  }
}
</style>
